import { AvailableLanguages } from '@repo/toolkit/language-types'
import { FileTypeEnum } from '@repo/toolkit/types'
import { z, ZodType } from 'zod'

import { FileInput } from '../../types/models/file/file-input'
import { createEnumSchema } from './enum-validation'
import { createNumberSchema } from './int-array-validation'
import { createStringSchema } from './string-validation'

type FileValidationOptions = {
  error?: string
  language?: AvailableLanguages
}

export const FILE_VALIDATION = ({
  error,
  language
}: FileValidationOptions = {}): ZodType<FileInput> =>
  z.object(
    {
      path: createStringSchema('chemin', { language }),
      name: createStringSchema('NOM', { language }),
      size: createNumberSchema('taille', { language }),
      type: createEnumSchema({ fieldName: 'type', enumType: FileTypeEnum, language }),
      caption: createStringSchema('caption', { nullish: true, language })
    },
    { message: error }
  )
